<template>
    <div class="col mb-3">
        <div class="card mb-3  h-100">
            <img class="card-img-top" v-bind:src="article.articleImage" v-bind:alt="article.articleImageAlt">
            <div class="card-body">
                <a v-bind:href="article.isRedirected ? article.urlOverride : article.url" class="stretched-link">
                    <h5 class="card-title filter-name">{{article.articleTitle}} </h5>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: ['article'],
    data: function(){
      return {};
    }
  };
</script>
